//Vishy 2025-02-24 This file was originally known as RewardsRedemption.tsx. It is now renamed to Redemption.tsx"
//Vishy 2025-02-23 User message changed.

import { Box, Text } from "@chakra-ui/react";
import Header from "../../Components/Common/Header";
import { useNavigate, useParams } from "react-router-dom";

type Props = {};

const Redemption = (props: Props) => {  //Vishy 2025-02-23 renamed as Redemption from RewardsRedemption
  const navigate = useNavigate();
  const { redemptionId } = useParams();
  const onClosePopUp = () => {
    navigate(`/buyer/rewards`);
  }
  return (
    <Box flexGrow={1} p={6} w={"100%"}>
      <Header backButton onClosePopUp={onClosePopUp}>{""}</Header>
      <Text
        textAlign={"center"}
        fontSize={"16px"}
        fontWeight={"bold"}
        mt={10}
        color={"black"}
      >
        Your redemption request is received.
      </Text>
      <Text
        textAlign={"center"}
        fontSize={"16px"}
        fontWeight={"bold"}
        mt={"130px"}
        color={"black"}
      >
        Your redemption Id is {redemptionId}
      </Text>
      <Text
        textAlign={"center"}
        fontSize={"12px"}
        fontWeight={"medium"}
        mt={2}
        color={"black"}
      >
        For any queries, email{" "}
        <a
          style={{ color: "#F5793D" }}
          href="mailto:support@aftr.network"
        >
          support@aftr.network
        </a>
      </Text>
    </Box>
  );
};

export default Redemption;
